var React = require('react');

function IconSort (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 8H4V6.66667H0V8ZM0 0V1.33333H12V0H0ZM0 4.66667H8V3.33333H0V4.66667Z"}));
}

IconSort.defaultProps = {"width":"12","height":"8","viewBox":"0 0 12 8","fill":"none"};

module.exports = IconSort;

IconSort.default = IconSort;
